<template>
  <v-container fluid style="padding: 0; height: 100%">
    <v-card
      :style="
        'height: 100%;' +
        (soMetaBackgroundColorCard
          ? 'background-color: ' + soMetaBackgroundColorCard
          : '')
      "
    >
      <v-row no-gutters>
        <v-toolbar dense flat style="background: transparent">
          <v-toolbar-title
            :style="
              soMetaTextColorTitle ? 'color: ' + soMetaTextColorTitle : ''
            "
            >{{ module.title }}</v-toolbar-title
          >
        </v-toolbar>
      </v-row>
      <v-row style="max-height: 80%; height: 80%; max-width: 100%; margin: 0">
        <e-chart
          v-if="loaded"
          :options="opts"
          :style="
            fakeData
              ? 'width: 100%; height: 250px; overflow: hidden'
              : 'width: 100%; height: 85%; overflow: hidden'
          "
          :autoresize="true"
          :theme="this.darkmode ? 'sensoronlinedark' : 'macarons'"
        />
        <span
          style="text-align: center; width: 100%; overflow: hidden; height: 10%"
          v-if="this.dataValue"
        >
          {{ humanDate(this.dataValue.createdAt) }}
        </span>
      </v-row>
      <v-row no-gutters style="padding-bottom: 1rem"> </v-row>
    </v-card>
  </v-container>
</template>

<script>
import { mapActions, mapState } from "vuex";
// import { format } from "date-fns";
import "echarts/lib/component/title";
import "echarts/lib/chart/gauge";
import Meta from "@/_helpers/ModuleMeta";

export default {
  name: "Gauge",
  mixins: [Meta],
  props: {
    settingsEnabled: {
      type: Boolean,
    },
    loading: {
      type: Boolean,
    },
    module: {
      default: {},
    },
    tag: {
      default: null,
    },
    timerTick: {
      default: null,
    },
    fakeData: {
      default: false,
    },
  },

  data() {
    return {
      opts: {
        series: [
          {
            type: "gauge",
            center: ["50%", "60%"],
            startAngle: 200,
            endAngle: -20,
            min: 0,
            max: 60,
            z: 9999,
            itemStyle: {
              color: "#4169E1",
            },
            progress: {
              show: true,
              width: 11,
            },

            pointer: {
              show: false,
            },
            axisLine: {
              show: false,
            },
            axisTick: {
              show: false,
            },
            splitLine: {
              show: false,
            },
            axisLabel: {
              show: false,
            },
            detail: {
              show: false,
            },
            data: [
              {
                value: 0,
              },
            ],
          },
          {
            type: "gauge",
            center: ["50%", "60%"],
            startAngle: 200,
            endAngle: -20,
            min: 0,
            max: 60,
            splitNumber: 5,
            itemStyle: {
              color: "#999",
            },
            progress: {
              show: false,
            },

            pointer: {
              show: true,
            },
            axisLine: {
              lineStyle: {
                width: 18,
                color: ["#6a995e"],
              },
            },
            axisTick: {
              show: true,
              distance: -30,
              splitNumber: 5,
              lineStyle: {
                width: 1,
                color: "#999",
              },
            },
            splitLine: {
              distance: -48,
              length: 10,
              lineStyle: {
                width: 3,
                color: "#999",
              },
            },
            axisLabel: {
              distance: -10,
              color: "#999",
              fontSize: 13,
              formatter: function (v) {
                return +v.toFixed(2);
              },
            },
            anchor: {
              show: false,
            },
            title: {
              show: true,
            },
            detail: {
              show: true,
              valueAnimation: true,
              width: "60%",
              lineHeight: 40,
              height: "15%",
              borderRadius: 8,
              offsetCenter: [0, "60%"],
              fontSize: 35,
              fontWeight: "bolder",
              formatter: "{value}",
              color: "inherit",
            },
            data: [
              {
                value: 0,
              },
            ],
          },
        ],
      },
      loaded: false,
      defaultColor: this.darkmode ? "#FFB347" : "#449DD1",
      backgroundColor: null,
      titleTextColor: null,
      successColor: "#62B58F",
      dataValue: null,
      defaultFormatter: "{value}",
    };
  },

  methods: {
    ...mapActions("tagData", { getData: "getTagDataWithMetrics" }),
    ...mapActions("alarms", ["getAlarms"]),

    setData(val) {
      let target = this.getTarget();
      if (target == undefined) this.opts.series.splice(0, 1);

      for (var i in this.opts.series) {
        if (i == 0 && target != undefined) {
          this.opts.series[i].data[0].value = +parseFloat(target).toFixed(2);
        } else {
          this.opts.series[i].data[0].value = +parseFloat(val).toFixed(2);
        }
      }
    },

    getTarget() {
      let value = undefined;
      for (var i in this.module.meta) {
        if (this.module.meta[i].key == "so_target") {
          return this.module.meta[i].valueMatch;
        }
      }
      return value;
    },

    getSufixPrefix() {
      let prefix = null;
      let sufix = null;
      for (var i in this.module.meta) {
        if (this.module.meta[i].key == "so_sufix") {
          sufix = this.module.meta[i].value;
        }

        if (this.module.meta[i].key == "so_prefix") {
          prefix = this.module.meta[i].value;
        }
      }
      return [prefix, sufix];
    },

    setFormatter() {
      let i = 0;
      if (this.opts.series.length > 1) {
        i = 1;
      }
      let format = "{value}";
      let preSuf = this.getSufixPrefix();
      if (preSuf[1]) {
        format = format + " " + preSuf[1];
      }
      if (preSuf[0]) {
        format = preSuf[0] + " " + format;
      }
      this.opts.series[i].detail.formatter = format;
    },

    initGauge() {
      let min = parseInt(this.module.min);
      let max = parseInt(this.module.max);
      for (var i in this.opts.series) {
        this.opts.series[i].min = min;
        this.opts.series[i].max = max;
      }

      this.setAlarmColors();
      this.setFormatter();
    },

    setAlarmColors() {
      if (
        this.fakeData ||
        this.module.meta.filter(
          (m) => m.key && m.key == "so_force_colors" && m.value == "true"
        ).length >= 1
      ) {
        this.setDefaultColors();
        return;
      }

      let i;
      if (this.opts.series.length > 1) {
        i = 1;
      } else {
        i = 0;
      }

      if (this.dataValue == null) return;

      let al = null;
      this.alarms.forEach((a) => {
        if (
          a.tagDataKey === this.dataValue.key &&
          a.tag.deveui === this.dataValue.tagDeveui &&
          a.active === true
        ) {
          al = a;
        }
      });

      if (this.alarms == null || this.dataValue == null || al == null) {
        this.setDefaultColors();
        return;
      }

      // Check the min value
      let min = parseInt(this.module.min);
      let max = parseInt(this.module.max);
      let span = 0;

      if (this.module.max < 0) {
        max = Math.abs(max);
      }

      if (this.module.min < 0) {
        min = Math.abs(min);
        span = min + max;
      } else {
        span = max - min;
      }

      // 11 - 6 = 5;  -10 + 16 = 6 / 21
      // 6|--------------------------------0-----|15
      let colors = [];
      if (al.limitLow && al.limitLow > this.module.min) {
        let v = al.limitLow - min;
        if (this.module.min < 0) {
          v = al.limitLow + min;
        }

        colors.push([Math.abs(v) / span - 0.001, "#F2726F"]);
      }

      if (al.limitHigh) {
        let v2 = al.limitHigh - min;
        if (this.module.min < 0) {
          v2 = al.limitHigh + min;
        }
        colors.push([Math.abs(v2) / span, "#62B58F"]);
      }

      colors.push([1, "#F2726F"]);
      if (this.opts.series[i])
        this.opts.series[i].axisLine.lineStyle.color = colors;
    },

    setDefaultColors() {
      let i;
      // If there are more series than 1 there is a series
      // for the target so we advance one.
      if (this.opts.series.length > 1) {
        i = 1;
      } else {
        i = 0;
      }

      // Set default color if there is no other colors
      if (this.opts.series[i] == undefined) return;
      this.opts.series[i].axisLine.lineStyle.color = [[1, "#62B58F"]];

      if (!this.module.meta) return;

      let colors = [];
      let styleMetas = this.module.meta.filter((m) => {
        if (m.key) return m.key.startsWith("so_style_meta");

        return false;
      });

      for (var j in styleMetas) {
        let style = styleMetas[j];
        // We only need to set the value max because of the way echarts work
        colors.push([style.valueMatch / 100, style.content]);
      }

      if (colors.length > 0) {
        // Sort the colors for correct viewing
        colors = colors.sort((a, b) => a[0] - b[0]);
        // Make sure the last value is extending to the end
        if (colors[colors.length - 1][0] < 1) {
          colors[colors.length - 1][0] = 1;
        }

        this.opts.series[i].axisLine.lineStyle.color = colors;
      }
    },

    async updateData() {
      let data = await this.getData({
        metrics: {
          tag: this.module.tag.deveui,
          key: this.module.key,
          limit: 1,
        },
      });

      if (data != undefined && data.length > 0) {
        this.dataValue = data[0];
        this.setData(this.dataValue.value);
      } else {
        this.setData(0);
      }
    },
  },

  computed: {
    ...mapState("configuration", ["darkmode"]),
    ...mapState("alarms", ["alarms"]),
  },

  async created() {
    if (!this.fakeData) {
      await this.getAlarms();
      let data = await this.getData({
        metrics: {
          tag: this.module.tag.deveui,
          key: this.module.key,
          limit: 1,
        },
      });

      if (data != undefined && data.length > 0) {
        this.dataValue = data[0];
        this.setData(this.dataValue.value);
      } else {
        this.dataValue = 0;
        this.setData(0);
      }
    } else {
      // Fake part for preview
      this.setData(35);
      this.module.min = 0;
      this.module.max = 45;
    }

    this.initGauge();
    this.loaded = true;
  },

  watch: {
    timerTick(v) {
      if (v % 4 == 0) {
        this.updateData();
      }
    },

    module(v1, v2) {
      if (v1.meta != v2.meta) this.setAlarmColors();
    },
  },
};
</script>